module.exports = __webpack_public_path__ + "media/icons/custom_datepicker_arrow-37ab0cd8.svg";